<template>
  <section class="section">
    <div v-if="state === 'CA'" class="container">
      <h1 class="title">Mile Auto is not offering New Policies in your area</h1>
      <p>
        We apologize for any inconvenience as Porsche Auto Insurance is
        currently unavailable to new customers in your state. If you would like
        to explore purchasing a new auto policy in California, please contact
        Hippo Insurance Agency at
        <a :href="'tel:1-877-838-8866'">(877) 838-8866</a>.
      </p>

      <p>
        To stay informed regarding availability of Porsche Auto Insurance in
        your state, please provide your information below.
      </p>

      <p>
        If you are a current Porsche Auto Insurance policy holder, please click
        the customer icon in the top right corner of this page and choose My
        Policy. You can also contact our Customer Concierge team between 9 AM
        and 5 PM at
        <span style="white-space: nowrap;"
          ><a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a></span
        >
        or email us at
        <span style="white-space: nowrap;"
          ><a :href="'mailto:' + $emailAddress">{{ $emailAddress }}</a></span
        >.
      </p>
    </div>
    <div v-else-if="$route.fullPath.includes('not-writing')" class="container">
      <p>
        Porsche Auto Insurance is temporarily unavailable to new customers in
        your state. We will be back online to serve our Porsche drivers in the
        near future. To stay informed regarding availability in your state,
        please provide your information below.
      </p>
      <p>
        If you are a current Porsche Auto Insurance policy holder, please click
        My Policy at the top of this page, or contact our Customer Concierge
        team between 9 AM and 5 PM at
        <span style="white-space: nowrap;"
          ><a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a></span
        >
        or email us at
        <span style="white-space: nowrap;"
          ><a :href="'mailto:' + $emailAddress">{{ $emailAddress }}</a></span
        >
      </p>
    </div>
    <div
      v-else-if="$route.fullPath.includes('weather-exception')"
      class="container"
    >
      <p>
        Due to weather conditions in your area, we are unable to complete your
        quote online at this time. Please retry your quote at a later date or
        contact us at
        <span style="white-space: nowrap;"
          ><a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a></span
        >
        for further assistance.
      </p>
    </div>
    <div v-else class="container">
      <h1 class="title">Coming soon</h1>
      <p>
        Porsche Auto Insurance is currently available in Arizona, Colorado,
        Florida, Georgia, Illinois, Ohio, Oregon, Tennessee, and Texas. We will
        be expanding to more states in the near future. To find out when we are
        launching in your state, please provide your information below and we
        will stay in touch.
      </p>
    </div>
    <div v-show="!$route.fullPath.includes('weather')" class="container">
      <AvailabilityForm
        isUnavailable="true"
        :queryState="state"
        @floodlight="floodlightUnavailable"
      ></AvailabilityForm>
    </div>
  </section>
</template>

<script>
import AvailabilityForm from '../components/shared/AvailabilityForm';
import { canUseAdvertising, safeGtag } from '@/utils/tracking';

export default {
  name: 'Unavailable',
  props: ['state'],
  components: {
    AvailabilityForm
  },
  methods: {
    floodlightUnavailable() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      } else if (!canUseAdvertising()) {
        return;
      } else {
        // console.log('2025 Floodlight 8 Active');
        // Porsche PAI Tailored Unavailable Location Quote Form
        let flDiv = document.body.appendChild(document.createElement('div'));
        let GDPR = '${GDPR}';
        let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
        flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
        flDiv.style.position = 'absolute';
        flDiv.style.top = '0';
        flDiv.style.left = '0';
        flDiv.style.width = '1px';
        flDiv.style.height = '1px';
        flDiv.style.display = 'none';
        flDiv.innerHTML = `<img id=${process.env.VUE_APP_FLOODLIGHT_ID +
          'FL_2025_08'} src="https://ad.doubleclick.net/ddm/activity/src=5368208;type=2025p0;cat=porsc0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1"/>`;
        if (process.env.VUE_APP_GOOGLE_ANALYTICS === 'enable') {
          safeGtag('advertising', 'event', 'conversion', {
            allow_custom_scripts: true,
            send_to: 'DC-5368208/2025p0/porsc0+standard'
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1 + p {
  margin-bottom: 2rem;

  @media (min-width: 1000px) {
    max-width: 900px;
  }
}

.column + .column {
  @media (max-width: 760px) {
    margin-top: -0.75rem;
    padding-top: 0;
  }
}
</style>
